<template>
  <div class="price-list-preview-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Podgląd cennika</h1>
      <div class="header-actions">
        <button class="btn-outline" @click="$router.push('/admin-profile/price-list')">Wróć do edycji</button>
        <button class="btn-primary" @click="refreshPreview">Odśwież podgląd</button>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Widok publiczny cennika</h2>
        <p class="section-subtitle">
          Poniżej znajduje się podgląd cennika tak, jak może być widoczny dla użytkowników.
        </p>
      </div>

      <div class="preview-wrapper">
        <PriceListVue :key="previewKey" />
      </div>
    </div>
  </div>
</template>

<script>
import PriceListVue from '@/components/HomeComponents/biz/PriceList.vue';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'PriceListPreview',
  components: { PriceListVue },
  setup() {
    return {
      authStore: useAuthStore(),
    };
  },
  data() {
    return {
      previewKey: 0,
    };
  },
  props: ['isVisible'],
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
  },
  methods: {
    refreshPreview() {
      this.previewKey += 1;
    },
  },
};
</script>

<style scoped lang="scss">
.price-list-preview-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.preview-wrapper {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  background: #ffffff;
  overflow: hidden;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.5rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 480px) {
  .price-list-preview-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .header-actions {
    width: 100%;
  }
}
</style>